import React from "react";
import Avatar from '@material-ui/core/Avatar';
import {GRANITE_6} from '../colors';

/**
 * Comments
 *
 * @param {Object} props
 *
 */
const UserAvatar = props => {
    const avatarBadgeStyle = {
        top:'20px',
        left:'20px',
        height:'18px',
        width: '18px',
        borderRadius: '100%',
        borderStyle: 'none',
        position:'absolute',
        backgroundColor: 'white',
        color:'#34573C',
        fontSize:'16px',
    };
    const staffBageStyle = {
        backgroundColor: '#34573C',
        padding:1
    };

    function Badge() {
        if (props.staff) {
            return <img style={{...avatarBadgeStyle, ...staffBageStyle}} src={`${window.Gaia.staticURL}img/logos_icons/simple-white.png`} />;
        }
        else if (props.ranger) {
            return <i style={avatarBadgeStyle} className="material-icons">stars</i>;
        }
        else {
            return (null);
        }
    }

    return (
        <div style={{
            padding: 2,
            borderColor: GRANITE_6,
            borderWidth: 1,
            borderRadius: '100%',
            borderStyle: 'solid',
            position:'relative',
            display:'inline-block',
            verticalAlign:'middle'
        }}>
            <Avatar
                data-userid={props.id}
                alt={props.name}
                style={{
                    width: 28,
                    height: 28,
                    borderRadius: '100%',
                    borderStyle: 'none',
                    position:'relative',
                }}
                src={props.image}
            />
            <Badge />
        </div>
    );
};

export default UserAvatar;
